import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import coursesData from "../../data/CourseData";
import InscriptionModal from "../modals/InscriptionModal";
import WhatsAppButton from "../header/WhatsAppButton";
import ContactModal from "../modals/ContactModal";
import Accordion from "../pages/Accordion";
import flechas from "../../assets/img/flechas.webp";
import logogarantia from "../../assets/img/sello_garantia.webp";
import { getLocation } from "../utils/GetLocation";
import { trackMetaEvent } from '../utils/MetaPixel';
import { CountdownTimer } from '../utils/CountdownTimer';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import testimonio1 from "../../assets/img/testimonioIntrodProg1.webp";
import testimonio2 from "../../assets/img/testimonioIntrodProg2.webp";
import testimonio3 from "../../assets/img/testimonioIntrodProg3.webp";
import testimonio4 from "../../assets/img/testimonioIntrodProg4.webp";
import testimonio5 from "../../assets/img/testimonioIntrodProg5.webp";
import testimonio6 from "../../assets/img/testimonioIntrodProg6.webp";
import imgHeader from "../../assets/img/page-header.webp";
import imgWhatsApp from "../../assets/img/whatsApp.svg";
import PresalePrices from "../utils/PresalePrices";


const CourseDetail = () => {

  const { id } = useParams();
  // Buscar el curso por ID en la lista de cursos
  const course = coursesData.find(course => course.id === id);
  
  const phoneNumber = "573028688273";
   const message = encodeURIComponent(
    `Quiero inscribirme en el curso de "${course.titleMain}" con la promoción de la página web pero aún tengo dudas y quisiera resolverlas`
  );
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  const [showModal, setShowModal] = useState(false); // Estado del modal
  const [price, setPrice] = useState({ oldPrice: "No Disponible", newPrice: "No Disponible", priceInscription: "No Disponible" });
  const [paymentMethods, setPaymentMethods] = useState({ names: "" });
  const [presalePrices, setPresalePrices] = useState({});

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  let countryValues = 'us';
  let countryPaymentMethods = 'default';

  //Mover el scroll al inicio cuando se carga la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getLocation().then(({ countryCode }) => {
      countryValues = course.values[countryCode] || course.values["us"]; // Si el país no está definido, usa USD
      countryPaymentMethods = course.paymentMethods[countryCode] || course.paymentMethods["default"]; // Si el país no está definido, usa los métodos default
      setPrice({ oldPrice: countryValues.oldPrice.toLocaleString("de-DE"), newPrice: countryValues.newPrice.toLocaleString("de-DE"), priceInscription: ((countryValues.newPrice) * 0.6).toLocaleString("de-DE"), currency: countryValues.currency, priceFormat: countryValues.newPrice });
      setPaymentMethods({ names: countryPaymentMethods });
      setPresalePrices(countryValues?.presale)
    });
  }, [course.values]);

  useEffect(() => {
    if (course) {
      // 🔹 Enviar evento de "ViewContent" cuando alguien entra a la página del curso
      trackMetaEvent('ViewContent', {
        content_name: course.title,
        content_category: 'Curso Online',
        content_ids: [course.id]
      });
    }
  }, [course]);

  const navigate = useNavigate();

  const handleScrollAndTrack = () => {
      // Navega al div con id="pricing"
      document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  
      // Ejecuta tu evento de tracking
      trackMetaEvent('Lead', { content_name: course.title });
    };

  // Si no se encuentra el curso, mostrar mensaje de "En desarrollo"
  if (!course.active) {
    return (
      <>
        {/* Header Section */}
        <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
          <img
            src={imgHeader}
            alt="Encabezado de página curso online"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
            style={{ zIndex: 0 }}
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />

          <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
              <h3 className="display-4 text-white text-uppercase">Detalles del curso</h3>
              <div className="d-inline-flex text-white">
                <p className="m-0 text-uppercase">
                  <Link to="/">Inicio</Link>
                </p>
                <i className="fa fa-angle-double-right pt-1 px-3"></i>
                <p className="m-0 text-uppercase">Detalles del curso</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5 text-center">
          <h2 style={{ backgroundColor: "red", color: "white" }}>El curso aún no está disponible, pero muy pronto abriremos inscripciones. 🎉</h2>
          <h3 className="text-center mt-4">Atento al lanzamiento los próximos días para obtener el precio de PREVENTA.</h3>
        </div>
        <div className="text-center">
          <button onClick={() => navigate("/")} className="px-4 py-2 btn-primary">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Contenido del Curso */}
      <div className="top-banner">
        <div className="scrolling-text">
          {course.hookMain}
        </div>
      </div>
      <div className="container py-5">
        <br></br>
        <br></br>
        <br></br>
        <div className="row">
          {/* Sección de Información del Curso */}
          <div className="col-lg-12">
            <div className="animation-container">
              {/*  <h1 className="fade-in">🎉 ¡Tu mejor inversión en educación está aquí!</h1> */}
              {/*  <h1 className="slide-in">🚀 Aprende a programar en solo 4 semanas</h1>*/}
              {/*<h1 className="typing-effect">{course.hookMain}</h1>*/}
            </div>
            <h1 className="text-primary text-center zoom-in">{course.title.map((part, index) => (
              <span key={index} style={part.style}>
                {part.text}{" "}
              </span>
            ))}</h1>
            <hr></hr>
            <h5 className="text-center" style={{ color: 'black' }}><b>{course.subtitle}</b></h5>
            <hr></hr>
            <h4 className="text-center">Fecha de inicio: {course.startDate}</h4>
             <div className="loader-container">
              <div className="loader-dot"></div>
              <div className="loader-dot"></div>
              <div className="loader-dot"></div>
              <div className="loader-dot"></div>
              <div className="loader-dot"></div>
            </div>
            <img src={course.imageIndex} alt={course.title} className="img-fluid rounded w-100 my-4" />
            <h2 className="text-center" style={{ backgroundColor: "red", color: "white" }}>OFERTA ESPECIAL POR TIEMPO LIMITADO</h2>
            <br></br>
            <div className="text-center"><h3>
              {course.hook.map((part, index) => (
                <span key={index} style={part.style}>
                  {part.text}{" "}
                </span>
              ))}</h3>
            </div>
            <br></br>
            <div className="text-center">
              <button className="px-4 py-2 buy-btn" onClick={handleScrollAndTrack}>🔥 Inscribirme Ahora</button>
            </div>
            <br></br>
            <div className="img-bonus">
              <img src={course.imgBonus} alt="Beneficios Curso Online" />
            </div>
            <div className="bg-gradient-to-r">
              ¿QUÉ BENEFICIOS OBTIENES CON ESTE CURSO? 🚀
            </div>
            <br></br>
            <ul>
              {course.benefits.map((item, index) => (
                <div key={index} className="text-justify">
                  <h5> {item} </h5>
                </div>
              ))}
            </ul>
            <div className="text-center">
              <button className="px-4 py-2 buy-btn" onClick={handleScrollAndTrack}>{course.botonHookText}</button>
            </div>
            <br></br>
            <div className="bg-gradient-to-r">
              {course.hookHeadband}
            </div>
            <h2 className="mt-4">PLAN DE ESTUDIO</h2>
            <Accordion course={course} />
            {course.id === "1" && (
              <div className="container-fluid py-5">
                <div className="container py-5">
                  <div className="text-center mb-5">
                    <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>
                      Testimonios
                    </h5>
                    <h1>¿Qué dicen algunos de nuestros estudiantes?</h1>
                    <h1>🌟🌟🌟🌟🌟</h1>
                    <h4>{course.rating}/5</h4>
                  </div>

                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    autoplay={{ delay: 8000, disableOnInteraction: false }}
                    pagination={{ clickable: true }}
                    navigation
                  >
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio1} alt="Estudiante 1" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio2} alt="Estudiante 2" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio3} alt="Estudiante 3" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio4} alt="Estudiante 4" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio5} alt="Estudiante 5" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="text-center">
                        <i className="fa fa-3x fa-quote-left text-primary mb-4"></i>
                        <div className="testimonial-text">
                          <img src={testimonio6} alt="Estudiante 6" className="testimonial-screen" />
                        </div>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            )}
            <h3 id="pricing" className="text-center mb-5">¡SI ESTAS CON VPN DESCONECTATE PARA VER PRECIOS DE TU PAIS!</h3>
            {course?.presale && !(countryValues?.presale) && (<div className="p-8">
              <PresalePrices values={presalePrices} currency={price.currency} />
            </div>)}
            <h1 className="animated-text">¡ESTAS A UN PASO DE CAMBIAR TU FUTURO CON ESTE CURSO!</h1>
            <br></br>
            <div className="dynamic-offer">
              <div className="discount-label">🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO 🔥</div>

              <h2 className="offer-title">¡No dejes pasar esta oportunidad!</h2>

              <div className="prices">
                <span className="old-price">
                  Antes:
                  <span className="crossed-price"> {price.oldPrice} {price.currency}</span>
                </span>
                <span className="new-price">AHORA: {price.newPrice} {price.currency}</span>
              </div>

              <button className="cta-button" onClick={() => {
                handleShowModal();
                trackMetaEvent('InitiateCheckout', { content_name: course.title, content_ids: [course.id], currency: price.currency, value: price.newPrice })
              }
              }>💥 INSCRIBIRME CON DESCUENTO</button>
              <p className="payment-info">
                ESTÁS AHORRANDO: {
                  (() => {
                    const cleanOld = parseFloat(price.oldPrice.replace(/\./g, "").replace(/,/g, "."));
                    const cleanNew = parseFloat(price.newPrice.replace(/\./g, "").replace(/,/g, "."));
                    const ahorro = cleanOld - cleanNew;

                    return ahorro >= 1000
                      ? Math.round(ahorro).toLocaleString()
                      : Math.round(ahorro).toString();
                  })()
                } {price.currency}
              </p>
              <h5 style={{ color: 'white' }}>Paga AHORA con:</h5>
              <h4 style={{ color: 'white' }}>{paymentMethods.names}</h4>
            </div>
            {course?.emergencyStopwatch && (<CountdownTimer />)}
            <h2 className="mt-4">ESTE CURSO ES PARA TI SI:</h2>
            <ul>
              {course.orientedTo.map((item, index) => (
                <div key={index} className="text-justify">
                  <h5>✔️ {item}</h5>
                </div>
              ))}
            </ul>
            <h1 className="gradient-text text-center">{course.SenseUrgency}</h1>
            <h2 className="mt-4">DURACIÓN</h2>
            <h5 className="mt-4">{course.duration}</h5>
            <h2 className="mt-4">MODALIDAD</h2>
            <h5 className="mt-4 text-justify">{course.mode}</h5>
            <hr style={{ border: "3px solid red", margin: "20px 0" }} />
            <h2 className="mt-4">COSTO</h2>
            <h5 className="mt-3 text-black font-weight-bold">Este curso normalmente tiene un valor de {price.oldPrice} {price.currency} pero en precio de PREVENTA te podrás llevar: </h5>
            <ul>
              {course.includedCourse.map((item, index) => (
                <div key={index} className="text-justify">
                  <h5>✔️ {item} </h5>
                </div>
              ))}
            </ul>
            <h1 className="mt-4 text-black font-weight-bold text-center" style={{ backgroundColor: "red", color: "white" }}>POR UN VALOR ÚNICO DE {price.newPrice} {price.currency}</h1>
            <h5 className="mt-4 text-black font-weight-bold text-center">SI QUIERES ASEGURAR TU CUPO YA Y NO TIENES EL DINERO COMPLETO, PUEDES REALIZAR LA INSCRIPCIÓN CON SÓLO EL 60% DE ESTE VALOR.</h5>
            <h4 className="mt-4 text-black font-weight-bold text-center">ES DECIR SÓLO PAGARÁS HOY {price.priceInscription} {price.currency} POR TU INSCRIPCIÓN.</h4>
            <hr style={{ border: "3px solid red", margin: "20px 0" }} />
            {course?.ebook && (<Link to={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=Hola. Me gusta el curso pero por ahora sólo quiero comprar el Ebook de Programación para Todos;`}><img className="img-bonus" src={course.ebook} alt={course.title} /></Link>)}
            <div className="bg-white py-12 px-6 md:px-24 flex flex-col md:flex-row items-center justify-between">


            </div>
            <div className="bg-white py-16 px-6">
              <h2 style={{ marginTop: '1rem', fontSize: '2rem', fontWeight: 'bold', color: '#1a202c', marginBottom: '1rem', textAlign: 'center' }}>
                GARANTÍA DE EXCELENCIA
              </h2>

              <div className="garantia-container">
                <div className="garantia-text">
                  <h4 style={{ color: '#2d3748', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
                    Con nuestro curso y el Sello de Excelencia de 3 Días, no solo aprenderás, sino con total confianza.
                  </h4>
                  <h6 style={{ color: '#2d3748', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
                    💡 Si en los primeros 3 días te arrepientes de tu compra, te devolvemos el 80% de tu inversión. Así de fácil.
                  </h6>
                  <h6 style={{ color: '#2d3748', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
                    🔐 Aprende sin miedo. Invierte sin riesgo.
                  </h6>
                  <h6 style={{ color: '#2d3748', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
                    🔥 Cientos de alumnos ya comenzaron… ¿y tú?
                  </h6>
                </div>
                <div className="garantia-img">
                  <img
                    src={logogarantia}
                    alt="Sello 7 días de garantía"
                    style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
                  />
                </div>
              </div>
            </div>

            <div className="text-center">
              <h4 className="text-center mt-4">
                Haz clic en el botón abajo si no quieres esperar más..
              </h4>
              <img src={flechas} alt="flechas" width="25%" />
            </div>
            <div className="text-center">
              <button className="px-4 py-2 buy-btn" onClick={() => {
                handleShowModal();
                trackMetaEvent('InitiateCheckout', { content_name: course.title, content_ids: [course.id], currency: price.currency, value: price.newPrice })
              }
              }>¡Inscribirme Ahora con Descuento!</button>
            </div>
            <br></br>
            <h6 className="text-center">
              <p>Pago 100% seguro en Dissemp Academy Courses desde cualquier país</p>
            </h6>
          </div>

          {/* Sección de Información del Instructor */}
          <div className="col-lg-12">
            <h2 className="mt-4 text-center">Por último pero no menos importante</h2>
            <h2 className="mt-4 text-center">NUESTRO INSTRUCTOR</h2>
            <div className="mentor-info p-4 text-white text-center rounded" style={{ backgroundColor: "#2d2e50", marginTop: "2%" }}>
              <img src={course.instructor.image} alt={course.instructor.name} className="rounded-circle mb-3" width="100" />
              <h4 className="text-light">{course.instructor.name}</h4>
              <p className="text-light font-weight-bold">{course.instructor.profession}</p>
              <p>{course.instructor.bio}</p>
            </div>
            <div className="center-flex text-center">
              <h2 className="mt-4">¿Aún tienes dudas? ¡Contáctanos al WhatsApp!</h2>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-button" onClick={() => trackMetaEvent('Lead', { content_name: course.title })}>
                <img
                  src={imgWhatsApp}
                  alt="WhatsApp Icon"
                  className="whatsapp-icon"
                />
                Click en este botón
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center">
        <button onClick={() => navigate("/")} className="px-4 py-2 btn-primary">
          IR A LA PÁGINA PRINCIPAL
        </button>
      </div>
      <WhatsAppButton course={course}/>
      {/* Modal de Inscripción */}
      <InscriptionModal show={showModal} handleClose={handleCloseModal} course={course} newPrice={price.priceFormat} currency={price.currency} country={countryValues} />
    </>
  );
};

export default CourseDetail;
